import { createContext, useContext } from "react";

// What a task list needs from NudgeApp, which owns the task editor and the writes: openTask(task), newTask(defaults)
// (the editor with fields preset, such as { dreamId }), saveTask(taskId, fields) (a promise) and `phase`, the part of
// the day it is now, for Add to today. Pages in src/features list tasks through useTaskRows without new props.
export const TaskActionsContext = createContext(null);
export const useTaskActions = () => {
  const actions = useContext(TaskActionsContext);
  if (!actions) throw new Error("useTaskActions needs TaskActionsContext, which NudgeApp provides (tests: renderWithTasks)");
  return actions;
};
